import { render, staticRenderFns } from "./flex-chip.vue?vue&type=template&id=813d22c8&"
import script from "./flex-chip.vue?vue&type=script&lang=js&"
export * from "./flex-chip.vue?vue&type=script&lang=js&"
import style0 from "./flex-chip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports